import axios from 'axios'
import useMyStore from '@/services/authStore'
import router from '@/router'

const baseDomain = new URL(window.location.origin)
//const baseDomain = 'https://staging-archistar.brainlab.digital/'
const baseURL = `${baseDomain}api/`
const { token, logout } = useMyStore()
const getToken = () => token.value
const instance = axios.create({
  baseURL,
  headers: { Authorization: getToken(), Accept: 'application/json' },
})

instance.interceptors.request.use(config => {
  console.log(baseDomain)
  const myToken = getToken()
  const myConfig = config
  if (myToken) {
    myConfig.headers.Authorization = myToken
  }
  return myConfig
})

instance.interceptors.response.use(response => response, error => {
  if (error.response && error.response.status === 401) {
    logout()
    if (router.currentRoute.name !== 'login') {
      router.push('/login')
    }
  }
  return Promise.reject(error)
})

export default instance
